/**
 * Checkout flow error codes.
 */
export enum CheckoutErrorCode {
  FETCH_DATA_FAILED = 'error.checkout.fetch_data.failed',
  DATA_LOAD_FAILED = 'error.checkout.data_load.failed',
  CONFIG_LOAD_FAILED = 'error.checkout.config_load.failed',
  CART_UPDATE_FAILED = 'error.checkout.cart_update.failed',
  ESTIMATE_CALCULATION_FAILED = 'error.checkout.estimate_calculation.failed',
  PM_LIST_RESYNC_FAILED = 'error.checkout.pm_list_resync.failed',
  RECOMMENDED_ADDONS_FAILED = 'error.checkout.recommended_addons.failed',
  SUBMIT_FAILED = 'error.checkout.submit.failed',
  COUPON_REMOVE_FAILED = 'error.checkout.coupon_remove.failed',
  POST_PAYMENT_ACTIONS_FAILED = 'error.checkout.post_payment_actions.failed',
  POST_PAYMENT_ACTIONS_UNSUPPORTED_HP_TYPE = 'error.checkout.post_payment_actions.unsupported_hp_type',
}
